import { EditOutlined } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { selectOptionsContactRole } from "../../../constants/selectOptions/selectOptionsContactRole";
import { useUnderwritingHook } from "../../../hooks/useUnderwritingHook";
import { loanDrilldownSet } from "../../../redux/actions/loanDrilldownActions";
import { loanPipelineClear } from "../../../redux/actions/loanPipelineActions";
import RffFormChanges from "../../finalForm/RffFormChanges";
import RffAddressEditingField from "../../finalForm/inputs/RffAddressEditingField";
import RffEmailField from "../../finalForm/inputs/RffEmailField";
import RffPhoneField from "../../finalForm/inputs/RffPhoneField";
import RffSelectToggleField from "../../finalForm/inputs/RffSelectToggleField";
import RffTextField from "../../finalForm/inputs/RffTextField";
import RffConditional from "../../finalForm/shared/RffConditional";
import RffRowGroup from "../../finalForm/shared/RffRowGroup";
import Flx from "../../layout/Flx";
import ContentArea from "../shared/ContentArea";
import SidebarSection from "../shared/SidebarSection";
import SidebarSectionTitle from "../shared/SidebarSectionTitle";

const EditContactFields = () => (
  <RffRowGroup>
    <RffTextField row name="firstName" label="First Name" required />
    <RffTextField row name="middleName" label="Middle Name" />
    <RffTextField row name="lastName" label="Last Name" required />
    <RffEmailField row name="emailAddress" label="Email" />
    <RffPhoneField row name="phone" label="Phone" />
    <RffTextField row name="company" label="Company" />
    <RffSelectToggleField
      name="loanRole"
      label="Loan Role"
      alphabetize
      options={selectOptionsContactRole}
      required
    />
    <RffConditional field="loanRole" value="Appraiser">
      <RffTextField
        size={12}
        row
        name="appraiserLicenseNumber"
        label="Appraiser License Number"
      />
    </RffConditional>
    <RffAddressEditingField name="address" label="Address" />
  </RffRowGroup>
);

const ContactEditForm = ({ contact, loanId, onClose, onSuccess }) => {
  const { updateLoanRelatedContact } = useUnderwritingHook();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const handleSubmit = useCallback(
    (changedValues) => {
      setLoading(true);
      updateLoanRelatedContact({
        dealId: loanId,
        contactId: contact?._id,
        contactData: changedValues,
        onSuccessFn: (response) => {
          setLoading(false);
          dispatch(loanDrilldownSet(response));
          dispatch(loanPipelineClear(response));
          onSuccess?.(response);
        },
        onFailFn: () => setLoading(false),
      });
    },
    [loanId, contact?._id, updateLoanRelatedContact, dispatch, onSuccess],
  );

  return (
    <RffFormChanges
      key={formKey}
      initialValues={contact}
      onSubmit={handleSubmit}
      loading={loading}
      suppressFooter
    >
      <Box>
        <Flx
          ac
          jb
          sx={{
            px: 1.5,
            py: 1.5,
            bgcolor: "#f1f2f5",
            padding: "16px",
            borderBottom: `1px solid rgb(100 116 139 / 9%)`,
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <SidebarSectionTitle primary icon={<EditOutlined />}>
            Edit Contact
          </SidebarSectionTitle>
          <Flx gap={1}>
            <Button
              color="gray"
              variant="outlined"
              onClick={() => {
                setFormKey((prev) => prev + 1);
                onClose?.();
              }}
            >
              Cancel
            </Button>
            <Box sx={{ background: "#ffffff", borderRadius: "4px" }}>
              <Button loading={loading} loadingPosition="end" type="submit">
                Save Changes
              </Button>
            </Box>
          </Flx>
        </Flx>

        <ContentArea>
          <Flx column g={0}>
            <SidebarSection underlinePosition="body" title="Contact">
              <EditContactFields />
            </SidebarSection>
          </Flx>
        </ContentArea>
      </Box>
    </RffFormChanges>
  );
};

export default ContactEditForm;
